import React from 'react';
import SplitRow from 'components/organisms/SplitRow/SplitRow';
import Txt from 'components/atoms/Txt/Txt';
import FullWidthCta from 'components/organisms/FullWidthCta/FullWidthCta';
import { CASHBACK, FAQ, SIGN_UP } from 'components/pages/pages';
import Heading from 'components/atoms/Heading/Heading';
import { StyledList } from 'components/atoms/StyledList/StyledList';
import SplitRowCta from 'components/organisms/SplitRow/SplitRowCta';
import Button from 'components/atoms/Button/Button';
import A from 'components/atoms/A/A';
import AppStoreLinks from 'components/atoms/AppStoreLinks/AppStoreLinks';
import LocaleAwareImage from 'components/atoms/LocaleAwareImage/LocaleAwareImage';

export interface Props {
  shouldSkipRedirect?: boolean;
}

const WhyQmee: React.FC<Props> = ({ shouldSkipRedirect }) => {
  return (
    <main>
      <SplitRow
        mobileColumnOrderSwapped
        contentAlignedTop
        isFirstRow
        leftColumn={
          <>
            <Heading level={1} uppercase>
              Why Qmee?
            </Heading>
            <Heading level={2} uppercase>
              Earn real cash rewards
            </Heading>
            <StyledList>
              <Txt component="li">Real cash rewards - not swag or points.</Txt>
              <Txt component="li">
                Cashout to PayPal or Venmo anytime, with no minimum cashout amount!
              </Txt>
              <Txt component="li">Spend your rewards on a gift card or donate to charity.</Txt>
            </StyledList>
          </>
        }
        rightColumn={
          <LocaleAwareImage
            src="/assets/why_qmee_img_1.png"
            alt="Why Qmee?"
            width={500}
            height={400}
          />
        }
      />

      <SplitRow
        rightColumn={
          <>
            <Heading level={2}>Take paid surveys</Heading>
            <StyledList>
              <Txt component="li">Complete online surveys to earn cash rewards!</Txt>
              <Txt component="li">Get matched with surveys that are tailored to your profile.</Txt>
              <Txt component="li">Activate your streak to increase your earnings!</Txt>
            </StyledList>
            <SplitRowCta>
              <Button
                component={A}
                color="primary"
                buttonType="primary"
                buttonSize="large"
                href={SIGN_UP.path}
                prefetch={false}
              >
                <Txt>Start Earning</Txt>
              </Button>
            </SplitRowCta>
          </>
        }
        leftColumn={
          <LocaleAwareImage
            src="/assets/why_qmee_img_2.png"
            alt="Take paid surveys"
            width={500}
            height={400}
          />
        }
      />

      <SplitRow
        mobileColumnOrderSwapped
        leftColumn={
          <>
            <Heading level={2}>Make money shopping online</Heading>
            <StyledList>
              <Txt component="li">Earn cashback when you buy the things you love.</Txt>
              <Txt component="li">Find deals for your favorite brands!</Txt>
              <Txt component="li">Save money by using exclusive discount codes.</Txt>
            </StyledList>
            <SplitRowCta>
              <Button
                component={A}
                color="primary"
                buttonType="primary"
                buttonSize="large"
                href={CASHBACK.path}
                prefetch={false}
              >
                <Txt>Show me cash back deals</Txt>
              </Button>
            </SplitRowCta>
          </>
        }
        rightColumn={
          <LocaleAwareImage
            src="/assets/why_qmee_img_3.png"
            alt="Make money shopping online"
            width={500}
            height={400}
          />
        }
      />

      <SplitRow
        rightColumn={
          <>
            <Heading level={2}>Available on-the-go</Heading>
            <StyledList>
              <Txt component="li">The mobile app is free for Android and iOS.</Txt>
              <Txt component="li">Earn extra cash anytime, anywhere!</Txt>
              <Txt component="li">
                Earn extra cash anytime, anywhere! Cashout your rewards when you&apos;re out &
                about.
              </Txt>
            </StyledList>
            <AppStoreLinks hideRating />
          </>
        }
        leftColumn={
          <LocaleAwareImage
            src="/assets/why_qmee_img_4.png"
            alt="Available on-the-go"
            width={500}
            height={400}
          />
        }
      />

      <SplitRow
        mobileColumnOrderSwapped
        leftColumn={
          <>
            <Heading level={2}>Fun online community</Heading>
            <StyledList>
              <Txt component="li">Get extra rewards with our social media giveaways!</Txt>
              <Txt component="li">Social media community.</Txt>
              <Txt component="li">Follow us on social media to get important updates!</Txt>
            </StyledList>
          </>
        }
        rightColumn={
          <LocaleAwareImage
            src="/assets/why_qmee_img_5.png"
            alt="Fun online community"
            width={500}
            height={400}
          />
        }
      />

      <SplitRow
        rightColumn={
          <>
            <Heading level={2}>We provide great support</Heading>
            <StyledList>
              <Txt component="li">Dedicated & friendly customer support team.</Txt>
              <Txt component="li">Responses from a real person.</Txt>
              <Txt component="li">Quick & helpful replies.</Txt>
            </StyledList>
          </>
        }
        leftColumn={
          <LocaleAwareImage
            src="/assets/why_qmee_img_6.png"
            alt="We provide great support"
            width={500}
            height={400}
          />
        }
      />

      <FullWidthCta
        title={<Txt>Frequently Asked Questions</Txt>}
        ctaText="FAQ's"
        ctaLink={FAQ.path}
      >
        Check out our FAQ’s to help with any unanswered questions
      </FullWidthCta>
    </main>
  );
};
export default WhyQmee;
